import promisify from "lib/promisify";
import Dispatcher from "Dispatcher";

/*
 * These control how much delay is added to helped Promises in "not production".
 * If DEV_DELAY is set to a negative number, production behaviour (no delay)
 * will be used. Otherwise, each Promise will be delayed a random amount between
 * DEV_DELAY and DEV_DELAY+DEV_DELAY_JITTER. The specific delay for a given
 * Promise is hidden, cannot be influenced, and is determined separately from
 * any other delayed Promises.
 *
 * If you're interested in checking "loading" status indicators, set DEV_DELAY
 * high.
 *
 * If you're interested in race conditions, set DEV_DELAY_JITTER high.
 */
const DEV_DELAY = -1;
const DEV_DELAY_JITTER = 100;

const myPromisify = process.env.NODE_ENV !== "production" && DEV_DELAY >= 0
    ? p => new Promise(resolve => {
        const doc = $(document).trigger("ajaxDelay");
        // eslint-disable-next-line no-settimeout
        setTimeout(() => {
            resolve(p.then(
                val => {
                    doc.trigger("ajaxResume");
                    return val;
                },
                err => {
                    doc.trigger("ajaxResume");
                    return Promise.reject(err);
                }
            ));
        }, DEV_DELAY + Math.random() * DEV_DELAY_JITTER);
    })
    : promisify;

const ajaxHelper = (
    ajaxDeferred,
    resolveActionTemplateOrCallback,
    rejectActionTemplateOrCallback,
) =>
    myPromisify(ajaxDeferred)
        .then(data => {
                Dispatcher.dispatch(
                    typeof resolveActionTemplateOrCallback === "function"
                        ? resolveActionTemplateOrCallback(data)
                        : {data, ...resolveActionTemplateOrCallback}
                );
                return data;
            }
            , error => {
                Dispatcher.dispatch(
                    typeof rejectActionTemplateOrCallback === "function"
                        ? rejectActionTemplateOrCallback(error)
                        : {error, ...rejectActionTemplateOrCallback}
                );
                return Promise.reject(error);
            });

export default ajaxHelper;



// WEBPACK FOOTER //
// ./app/data/util/ajaxHelper.js